import { useEffect } from "react";

/**
 * Lightweight, SPA-friendly SEO updater. Updates <title>, meta description,
 * canonical and Open Graph tags on route change. Avoids the react-helmet
 * dependency to keep the bundle lean.
 */
const BASE = "https://cre8-studio.de";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title}. CRE8 Studio GmbH`
      : "Medienagentur für Social Media, Werbevideos & Performance Ads | CRE8 Studio GmbH";
    document.title = fullTitle;

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }

    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);

    const canonical = `${BASE}${path}`;
    setMeta("property", "og:url", canonical);
    setLink("canonical", canonical);

    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
  }, [title, description, path, noindex]);

  return null;
}
